module.exports = __webpack_public_path__ + "img/rep-placeholder.f797f17f.jpg";